export const addMedicationToFavoriteEndpoint = (id: string) =>
  `/medications/${id}/favorites`;
